module.exports = __webpack_public_path__ + "static/HeroImage-3e561308e151b3d14f324eada3309ed0.png";